export default [
    {
        name: "公司简介",
        sub_navs: []
    },
    {
        name: "关于我们",
        sub_navs: [
            {
                name: "成功案例"
            },
            {
                name: "团队介绍"
            },
            {
                name: "定制服务"
            }
        ]
    },
    {
        name: "人才招聘",
        sub_navs: [
            {
                name: "销售人员"
            },
            {
                name: "技术人员"
            }
        ]
    },
    {
        name: "联系我们",
        sub_navs: [
            {
                name: "联系电话"
            },
            {
                name: "公司地址"
            }
        ]
    }
];
